import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "swiper" }
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = { class: "swiper-slide" }
const _hoisted_4 = { class: "swiper-slide" }
const _hoisted_5 = { class: "swiper-slide" }
const _hoisted_6 = { class: "swiper-slide" }
const _hoisted_7 = { class: "swiper-slide" }
const _hoisted_8 = { class: "display-flex ion-justify-content-center" }
const _hoisted_9 = {
  id: "google-sign-in",
  class: "display-flex ion-justify-content-center"
}
const _hoisted_10 = { class: "display-flex ion-justify-content-center ion-padding-top" }
const _hoisted_11 = {
  key: 1,
  class: "display-flex ion-justify-content-center google-play-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_intro = _resolveComponent("intro")!
  const _component_continue_with_google = _resolveComponent("continue-with-google")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "sign-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "12",
                sizeMd: "12",
                sizeLg: "12",
                sizeXl: "12",
                style: {"padding-top":"unset","padding-bottom":"unset"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_intro, { "current-index": 0 })
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_intro, { "current-index": 1 })
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_intro, { "current-index": 2 })
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_intro, { "current-index": 3 })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, [
                            (_ctx.isAndroid)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "display-flex ion-justify-content-center",
                                  role: "button",
                                  tabindex: "0",
                                  "aria-label": "Continue with Google",
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                                  onKeydown: [
                                    _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["prevent"]), ["enter"])),
                                    _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["prevent"]), ["space"]))
                                  ]
                                }, [
                                  _createVNode(_component_continue_with_google)
                                ], 32))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                              [_vShow, !_ctx.isAndroid]
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_ion_card_subtitle, { class: "ion-text-center link-container" }, {
                                default: _withCtx(() => [
                                  _cache[4] || (_cache[4] = _createTextVNode(" By creating your account, you agree with our ", -1)),
                                  _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                      _createTextVNode(" Privacy Policy ", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            (!_ctx.isAndroid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("a", {
                                    href: "https://play.google.com/store/apps/details?id=com.emtiajium.firecracker.collaborative.vocab.practice&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
                                    target: "_blank",
                                    class: "display-flex ion-justify-content-center"
                                  }, [
                                    _createElementVNode("img", {
                                      alt: "Get it on Google Play",
                                      src: "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
                                      class: "google-play"
                                    })
                                  ], -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}